<template>
  <div :class="{['c-question-block c-question-block--detail -'+selectedMenu]:true}" >
    <label :for="`chapter${section.id}`" class="c-parts-accordion-label"></label>
    <div class="c-question-block__inner">
      <div class="c-question-block__label">
        <span class="c-parts-homework" v-if="homeworkSection(section.id)">宿題</span>
      </div>
      <div class="c-question-block__titleBox">
        <div class="c-question-block__box">
          <div class="c-question-block__box__chapter">
            <span class="c-parts-label -chapter">{{section.sort_order}}</span>
            <div class="title">
              <markdown-view :rawText="section.title" :souruby="isSouruby"/>
            </div>
          </div>
          <div class="c-question-block__box__inner">
            <progress-bar ref="refProgressBar" :percentage="getPercentage(section.id)"></progress-bar>
            <textbook-page-number :page-number-range="section.textbook_page_range" v-if="section.textbook_page_range">
              {{section.textbook_page_range}}
            </textbook-page-number>
          </div>
        </div>
        <star-medal
          :number-of-star-medal="getStarMedal(section.id)">
        </star-medal>
      </div>
      <div class="c-accordion">
        <input type="checkbox" :id="`chapter${section.id}`" class="c-parts-accordion-input" v-model="isOpenLocal" @change="open()">
        <div class="c-accordion__cont c-parts-accordion-content">
          <div class="c-question-content-wrap">
            <div class="c-question-content c-question-content--review"
              v-if="countReview(section.id)>0" @click.stop>
              <div class="c-question-content__text c-question-content__text--notlink">
                <div class="c-question-content__text__inner">
                  <span class="c-parts-review -right">要復習</span>
                  <div class="block">
                    <p>問題をまとめて<ruby>解<rp>(</rp><rt>と</rt><rp>)</rp></ruby>く</p>
                    <p class="block__count">問題数 <span class="label">{{countReview(section.id)}}</span>問</p>
                  </div>
                  <div class="button">
                    <a href="javascript:void(0)" class="c-button-blue -small" @click.stop="emit('open-section-review', section)" name="S3-3-review-section-btn">
                      <span class="label -pen">
                        復習する
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="bgReview">
                <div class="bgReview__inner">
                </div>
              </div>
              <div class="bgReview">
                <div class="bgReview__inner">
                </div>
              </div>
            </div>

            <div class="c-question-content c-question-content--clear"
              v-for="question_set in section.question_sets">
              <span class="c-parts-bubble" v-if="question_set.id == workStore.last_learning_question_set_id">いま解いた問題</span>
              <div :class="{'c-question-content__text c-question-content__text--notlink -no-shadow': true, '-finished': question_set.id == workStore.last_learning_question_set_id}">
                <div class="c-question-content__text__inner -with-frame">
                  <div class="c-question-content__text__header">
                    <div class="c-parts-homework-information -question" v-if="homeworkInfo(question_set.id).length != 0">
                      <div class="c-parts-homework-information-item -small">
                        <div class="c-parts-homework-information-label">宿題</div>
                        <div class="c-parts-homework-information-status">
                          <div class="c-parts-homework-status" :class="{[homeworkInfo(question_set.id)[0].statusClass]: true}">{{homeworkInfo(question_set.id)[0].status}}</div>
                        </div>
                      </div>
                    </div>
                    <div class="c-question-content__text__header-right">
                      <span v-if="isInterruptionData(question_set.id)" class="c-parts-frame -interrupt">中断した学習</span>
                      <div class="c-parts-last-learning -chapter">
                        <three-stars
                          :number-of-stars="lastStudy(section.id, question_set.id).progress_stars">
                        </three-stars>
                      </div>
                    </div>
                  </div>
                  <div class="block">
                    <div class="c-parts-frame-wrapper">
                      <span v-if="question_set.question_set_label.display_name" :class="{'c-parts-frame -one':true, '-application':question_set.question_set_label.display_name == '応用問題'}">{{question_set.question_set_label.display_name[0]}}</span>
                    </div>
                    <markdown-view :rawText="question_set.title" :souruby="isSouruby"/>
                  </div>
                  <div class="c-question-content__button-wrapper">
                    <div class="c-question-content__button">
                      <p :class="{'c-question-content__button-history': true, '-review': isReview(question_set.id)}">
                        <template v-if="lastStudy(section.id, question_set.id).last_studied_at">
                          前回学習：<span class="num">{{parseInt(lastStudy(section.id, question_set.id).last_studied_at.slice(5,7))}}</span>月<span class="num">{{parseInt(lastStudy(section.id, question_set.id).last_studied_at.slice(8,10))}}</span>日
                        </template>
                        <template v-else>
                          未学習
                        </template>
                      </p>
                      <div class="button">
                        <div v-if="isInterruptionData(question_set.id)" class="c-button-blue -small-2" @click="emit('open-interruption-modal', {section: section, question_set: question_set})" name="S3-3-question-set-btn">
                          <span class="label -refresh">学習を再開</span>
                        </div>
                        <div v-else class="c-button-blue -small-2" @click="emit('open-question-modal', {section: section, question_set: question_set})" name="S3-3-question-set-btn">
                          <span class="label -pen">学習を開始</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="c-accordion__btn c-parts-accordion-btn">
          <div class="c-accordion__btn__inner">
            <div class="c-accordion__btn__inner__box" name="S3-3-accordion-btn">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {ref, onMounted, watch} from "vue";
  import {ISection, ISectionProgress, IReviewTag, IHomeworkQuestionSet} from "@/consts/interfaces";
  import AudioPlayer from '@/consts/sounds';
  import HomeworkInfo from "@/util/homework-info";
  import { useWorkStore } from '@/store/student/work_store';
  import { useAccountStore } from '@/store/student/account_store';

  const audioPlayer = AudioPlayer.getInstance()
  const workStore = useWorkStore()
  const accountStore = useAccountStore()
  const isOpenLocal = ref(false)
  const refProgressBar = ref(null)

  const props = withDefaults(
    defineProps<{
      section?: ISection | any;
      isOpen?: boolean;
      selectedMenu?: string;
      isSouruby?: boolean;
      oldSectionProgress?: {[id: string] : ISectionProgress} | any;
      reviewTags?: IReviewTag[];
      homeworkQuestionsets?: IHomeworkQuestionSet[];
    }>(),
    {
      section: () => {},
      isOpen: false,
      selectedMenu: "",
      isSouruby: false,
      oldSectionProgress: () => {},
      reviewTags: () => [],
      homeworkQuestionsets: () => [],
    }
  );

  const emit = defineEmits<{
    (e: 'is-open-accordion', id: {section_id: number, value: boolean}): void,
    (e: 'open-question-modal', id: {section: any, question_set: any}): void,
    (e: 'open-interruption-modal', id: {section: any, question_set: any}): void,
    (e: 'open-section-review', id: any): void,
  }>()

  onMounted(() => {
    isOpenLocal.value =  props.isOpen
  })
  function isInterruptionData(id: number):boolean {
    return workStore.study_break_data[workStore.selectedWorkId]?.break_data?.question_set_id === id
  }
  // sectionが宿題対象かチェック
  function homeworkSection(section_id: number){
    return props.homeworkQuestionsets.some(h => section_id == h.section_id)
  }
  // 出題単位が宿題対象かチェック
  function homeworkQuestionset(question_set_id: number){
    return props.homeworkQuestionsets.some(h => question_set_id == h.question_set_id)
  }
  // 出題単位に表示する宿題情報取得
  function homeworkInfo(question_set_id: number){
    const hwInfo = new HomeworkInfo(question_set_id, props.homeworkQuestionsets)
    return hwInfo.info;
  }
  function getPercentage(section_id: number): number | null {
    if(workStore.sectionProgress[section_id]){
      return workStore.sectionProgress[section_id].progress
    }
    return null
  }
  function getStarMedal(section_id: number): number{
    if(workStore.sectionProgress[section_id]){
      return workStore.sectionProgress[section_id].number_of_starmedal
    }
    return 0
  }
  function countReview(section_id: number){
    return props.reviewTags.filter(item => item.question.section_id == section_id).length
  }
  function isReview(qs_id){
    const review_tag = props.reviewTags.filter(item => item.question.question_set_id == qs_id)
    return review_tag.length != 0
  }
  function lastStudy(section_id, qs_id){
    if(props.oldSectionProgress[section_id]){
      const question_set: Array<any> = props.oldSectionProgress[section_id].question_sets.filter(item=>{
          return item.id == qs_id
      })
      if(question_set.length>0 && question_set[0].latest_question_set_history){
        return question_set[0].latest_question_set_history
      }
    }
    return {
      "last_studied_at": "",
      "progress_stars": 0
    }
  }
  function open() {
    if(accountStore.isSoundEnabled){audioPlayer.buttonSound().play()}
    emit("is-open-accordion", {section_id: props.section.id, value: isOpenLocal.value})
  }
  watch(
    () => props.isOpen,
    () => {
      isOpenLocal.value = props.isOpen
    }
  )
  defineExpose({refProgressBar})
</script>
